module.exports = __webpack_public_path__ + "img/lobby_hosting_kq.d882dfda.png";